export default __webpack_public_path__ + "static/media/assetSample3@2x.e46ccd1a.png";